import axios from "axios";
import React, { useState } from "react";
import { baseUrl } from "./baseUrl";
import { toast } from "react-toastify";
import Rate from "rc-rate";
import 'rc-rate/assets/index.css';

const CommentModal = (props) => {
    const [commentText, setCommentText] = useState("");
    const [rating, setRating] = useState(0);
    const commentHandler = (e) => {
        let data = new FormData();
        data.append("comment", commentText);
        rating !== 0 && data.append("rate", rating);
        let config = {
            method: "POST",
            url: `${baseUrl}/${props.id}/comment`,
            data: data,
        };
        axios(config)
            .then((response) => {
                props.setShow(false);
            })
            .catch(function (err) {
                toast.error(err.response.data.message, {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            });
    };
    return (
        <div className="comments" id="comments">
            <div className="head">
                <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M8.5 19H8C4 19 2 18 2 13V8C2 4 4 2 8 2H16C20 2 22 4 22 8V13C22 17 20 19 16 19H15.5C15.19 19 14.89 19.15 14.7 19.4L13.2 21.4C12.54 22.28 11.46 22.28 10.8 21.4L9.3 19.4C9.14 19.18 8.77 19 8.5 19Z"
                        stroke="#FF9A51"
                        strokeWidth="1.5"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        opacity="0.4"
                        d="M7 8H17"
                        stroke="#FF9A51"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        opacity="0.4"
                        d="M7 13H13"
                        stroke="#FF9A51"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
                نظرات
            </div>
            <div className="mt-4 dir-ltr">
                <Rate
                    value={rating}
                    onChange={(value) => setRating(value)}
                    count={5}
                    style={{ fontSize: "32px" }}
                />
            </div>
            <div className="new-comment">
                <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        opacity="0.4"
                        d="M12.1202 12.78C12.0502 12.77 11.9602 12.77 11.8802 12.78C10.1202 12.72 8.72021 11.28 8.72021 9.50998C8.72021 7.69998 10.1802 6.22998 12.0002 6.22998C13.8102 6.22998 15.2802 7.69998 15.2802 9.50998C15.2702 11.28 13.8802 12.72 12.1202 12.78Z"
                        stroke="#F15A22"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        opacity="0.34"
                        d="M18.7398 19.3801C16.9598 21.0101 14.5998 22.0001 11.9998 22.0001C9.39977 22.0001 7.03977 21.0101 5.25977 19.3801C5.35977 18.4401 5.95977 17.5201 7.02977 16.8001C9.76977 14.9801 14.2498 14.9801 16.9698 16.8001C18.0398 17.5201 18.6398 18.4401 18.7398 19.3801Z"
                        stroke="#F15A22"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                        stroke="#F15A22"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
                <div className="comment-card">
                    <div className="head-card">
                        <div className="comment-rate">
                            <svg
                                width="68"
                                height="11"
                                viewBox="0 0 68 11"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    opacity="0.1"
                                    d="M6 0L7.34708 4.1459H11.7063L8.17963 6.7082L9.52671 10.8541L6 8.2918L2.47329 10.8541L3.82037 6.7082L0.293661 4.1459H4.65292L6 0Z"
                                    fill="#F15A22"
                                />
                                <path
                                    opacity="0.3"
                                    d="M20 0L21.3471 4.1459H25.7063L22.1796 6.7082L23.5267 10.8541L20 8.2918L16.4733 10.8541L17.8204 6.7082L14.2937 4.1459H18.6529L20 0Z"
                                    fill="#F15A22"
                                />
                                <path
                                    d="M34 0L35.3471 4.1459H39.7063L36.1796 6.7082L37.5267 10.8541L34 8.2918L30.4733 10.8541L31.8204 6.7082L28.2937 4.1459H32.6529L34 0Z"
                                    fill="#F15A22"
                                    fill-opacity="0.5"
                                />
                                <path
                                    d="M48 0L49.3471 4.1459H53.7063L50.1796 6.7082L51.5267 10.8541L48 8.2918L44.4733 10.8541L45.8204 6.7082L42.2937 4.1459H46.6529L48 0Z"
                                    fill="#F15A22"
                                    fill-opacity="0.8"
                                />
                                <path
                                    d="M62 0L63.3471 4.1459H67.7063L64.1796 6.7082L65.5267 10.8541L62 8.2918L58.4733 10.8541L59.8204 6.7082L56.2937 4.1459H60.6529L62 0Z"
                                    fill="#F15A22"
                                />
                            </svg>
                        </div>
                    </div>
                    <textarea
                        onChange={(e) => setCommentText(e.target.value)}
                        value={commentText}
                        name="comment"
                    ></textarea>
                    <div className="flex-end">
                        <button onClick={commentHandler}>ثبت نظر</button>
                    </div>
                </div>
            </div>
            {props.item &&
                props.item.length !== 0 &&
                props.item.map((item) => {
                    return (
                        <div className="comment-card">
                            <div className="head-card">
                                <svg
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        opacity="0.4"
                                        d="M12.1202 12.78C12.0502 12.77 11.9602 12.77 11.8802 12.78C10.1202 12.72 8.72021 11.28 8.72021 9.50998C8.72021 7.69998 10.1802 6.22998 12.0002 6.22998C13.8102 6.22998 15.2802 7.69998 15.2802 9.50998C15.2702 11.28 13.8802 12.72 12.1202 12.78Z"
                                        stroke="#F15A22"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        opacity="0.34"
                                        d="M18.7398 19.3801C16.9598 21.0101 14.5998 22.0001 11.9998 22.0001C9.39977 22.0001 7.03977 21.0101 5.25977 19.3801C5.35977 18.4401 5.95977 17.5201 7.02977 16.8001C9.76977 14.9801 14.2498 14.9801 16.9698 16.8001C18.0398 17.5201 18.6398 18.4401 18.7398 19.3801Z"
                                        stroke="#F15A22"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                                        stroke="#F15A22"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                                <div className="comment-rate">
                                    {item.rate}
                                    <svg
                                        width="24"
                                        height="11"
                                        viewBox="0 0 24 11"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            opacity="0.1"
                                            d="M6 0L7.34708 4.1459H11.7063L8.17963 6.7082L9.52671 10.8541L6 8.2918L2.47329 10.8541L3.82037 6.7082L0.293661 4.1459H4.65292L6 0Z"
                                            fill="#F15A22"
                                        />
                                        <path
                                            opacity="0.3"
                                            d="M9 0L10.3471 4.1459H14.7063L11.1796 6.7082L12.5267 10.8541L9 8.2918L5.47329 10.8541L6.82037 6.7082L3.29366 4.1459H7.65292L9 0Z"
                                            fill="#F15A22"
                                        />
                                        <path
                                            d="M12 0L13.3471 4.1459H17.7063L14.1796 6.7082L15.5267 10.8541L12 8.2918L8.47329 10.8541L9.82037 6.7082L6.29366 4.1459H10.6529L12 0Z"
                                            fill="#F15A22"
                                            fill-opacity="0.5"
                                        />
                                        <path
                                            d="M15 0L16.3471 4.1459H20.7063L17.1796 6.7082L18.5267 10.8541L15 8.2918L11.4733 10.8541L12.8204 6.7082L9.29366 4.1459H13.6529L15 0Z"
                                            fill="#F15A22"
                                            fill-opacity="0.8"
                                        />
                                        <path
                                            d="M18 0L19.3471 4.1459H23.7063L20.1796 6.7082L21.5267 10.8541L18 8.2918L14.4733 10.8541L15.8204 6.7082L12.2937 4.1459H16.6529L18 0Z"
                                            fill="#F15A22"
                                        />
                                    </svg>
                                </div>
                            </div>
                            <p>{item.comment}</p>
                            {/* <div className="like-deslike">
                                <div className="deslike-div">
                                    <svg
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            opacity="0.4"
                                            d="M16.5197 5.65039L13.4197 3.25039C13.0197 2.85039 12.1197 2.65039 11.5197 2.65039H7.71973C6.51973 2.65039 5.21973 3.55039 4.91973 4.75039L2.51973 12.0504C2.01973 13.4504 2.91973 14.6504 4.41973 14.6504H8.41973C9.01973 14.6504 9.51973 15.1504 9.41973 15.8504L8.91973 19.0504C8.71973 19.9504 9.31973 20.9504 10.2197 21.2504C11.0197 21.5504 12.0197 21.1504 12.4197 20.5504L16.5197 14.4504"
                                            stroke="black"
                                            strokeWidth="1.5"
                                            strokeMiterlimit="10"
                                        />
                                        <path
                                            d="M21.6196 5.65049V15.4505C21.6196 16.8505 21.0196 17.3505 19.6196 17.3505H18.6196C17.2196 17.3505 16.6196 16.8505 16.6196 15.4505V5.65049C16.6196 4.25049 17.2196 3.75049 18.6196 3.75049H19.6196C21.0196 3.75049 21.6196 4.25049 21.6196 5.65049Z"
                                            stroke="black"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                    <div className="num-badge">23</div>
                                </div>
                                <div className="like-div">
                                    <svg
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            opacity="0.4"
                                            d="M7.47998 18.35L10.58 20.75C10.98 21.15 11.88 21.35 12.48 21.35H16.28C17.48 21.35 18.78 20.45 19.08 19.25L21.48 11.95C21.98 10.55 21.08 9.34997 19.58 9.34997H15.58C14.98 9.34997 14.48 8.84997 14.58 8.14997L15.08 4.94997C15.28 4.04997 14.68 3.04997 13.78 2.74997C12.98 2.44997 11.98 2.84997 11.58 3.44997L7.47998 9.54997"
                                            stroke="#F15A22"
                                            strokeWidth="1.5"
                                            strokeMiterlimit="10"
                                        />
                                        <path
                                            d="M2.37988 18.3499V8.5499C2.37988 7.1499 2.97988 6.6499 4.37988 6.6499H5.37988C6.77988 6.6499 7.37988 7.1499 7.37988 8.5499V18.3499C7.37988 19.7499 6.77988 20.2499 5.37988 20.2499H4.37988C2.97988 20.2499 2.37988 19.7499 2.37988 18.3499Z"
                                            stroke="#F15A22"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                    <div className="num-badge">23</div>
                                </div>
                            </div> */}
                        </div>
                    );
                })}
        </div>
    );
};

export default CommentModal;
